<template>
  <!-- <PrazoEncerrado v-if="!processoInscricao" /> -->
  <v-row>
    <v-col cols="12" v-text="$route.name" class="grey--text text-h2" />
    <v-col cols="12" class="px-0">
      <v-col cols="12">
        <CPTInput
          v-model="enrollment"
          v-maska="'###########'"
          autofocus
          label="Matrícula*"
          counter="11"
          @input="onInputEnrollment"
          @keydown.enter="isValidEnrollment && getStudent(enrollment)"
          type="number"
        />
      </v-col>
      <v-col cols="12 d-flex justify-end">
        <CPTBtn
          label="Buscar"
          icon="mdi-magnify"
          :disabled="!isValidEnrollment"
          :loading="loading"
          @click="getStudent(enrollment)"
        />
      </v-col>

      <v-skeleton-loader
        v-if="loading"
        :types="{ sections: 'heading, list-item-two-line@4' }"
        type="sections@2"
        class="mt-5"
      />

      <v-form
        v-else-if="student"
        @submit.prevent="onSubmit"
        ref="form"
        lazy-validation
        class="d-flex flex-wrap"
      >
        <!-- Student data -->
        <v-col cols="12">
          <CPTSubtitle label="Dados do aluno" />
        </v-col>

        <v-col cols="12">
          <CPTInput v-model="student.nome" label="Nome*" disabled required />
        </v-col>

        <v-col cols="12">
          <CPTInput
            v-model="student.nomeUnidade"
            label="Unidade de ensino*"
            disabled
            required
          />
        </v-col>

        <v-col cols="12">
          <CPTInput
            v-model="student.nomeEtapa"
            label="Etapa*"
            disabled
            required
          />
        </v-col>

        <v-col cols="12" class="pb-0">
          <CPTTextArea
            v-model="observacao"
            auto-grow
            label="Observação"
            outlined
          />
        </v-col>

        <v-col cols="12" class="d-flex flex-wrap">
          <v-col cols="12">
            <CPTSubtitle label="Endereço" />
          </v-col>

          <v-col cols="12" md="2">
            <CPTInput
              v-model="student.endereco.cep"
              label="CEP"
              v-maska="'#####-###'"
              disabled
            />
          </v-col>
          <v-col cols="12" md="4">
            <CPTInput
              v-model="student.endereco.rua"
              label="Rua*"
              required
              disabled
            />
          </v-col>
          <v-col cols="12" md="2">
            <CPTInput
              v-model="student.endereco.numero"
              v-maska="'#*'"
              label="Número"
              disabled
            />
          </v-col>
          <v-col cols="12" md="4">
            <CPTInput
              v-model="student.endereco.bairro"
              label="Bairro*"
              required
              disabled
            />
          </v-col>
          <v-col cols="12" md="6">
            <CPTAutocomplete
              v-model="state"
              label="Estado*"
              @change="getCities(true)"
              :items="states"
              noDataText="Estado não encontrado"
              item-text="nome"
              clearable
              return-object
              required
              disabled
            />
          </v-col>
          <v-col cols="12" md="6">
            <CPTAutocomplete
              v-model="student.endereco.cidade"
              label="Cidade*"
              :items="cities"
              item-text="nome"
              noDataText="Cidade não encontrada"
              return-object
              clearable
              required
              disabled
            />
          </v-col>
          <v-col cols="12">
            <CPTInput
              v-model="student.endereco.complemento"
              label="Complemento"
              disabled
            />
          </v-col>
        </v-col>

        <v-col v-if="isConselhoTutelar" cols="12">
          <v-row>
            <v-col cols="12" class="ml-5">
              <p class="font-weight-medium">
                Aos cuidados do Conselho Tutelar
              </p>
              <p>
                Conselheiro:
                {{ student.pessoa?.conselheiroNome || "Não informado" }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="!isConselhoTutelar" cols="12">
          <v-row>
            <CPTSubtitle label="Responsáveis" />
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <CPTInput
                v-model="documentos.nomeResponsavel1"
                label="Nome (Responsável 1)*"
                required
              />
            </v-col>
            <v-col cols="12" md="6">
              <CPTInput
                v-model="documentos.cpfResponsavel1"
                v-maska="'###.###.###-##'"
                label="N° do CPF (Responsável 1)*"
                placeholder="000.000.000-00"
                required
                :validator="[(cpf) => isValidCPF(cpf) || 'CPF inválido']"
              />
            </v-col>
            <v-col cols="12" md="6">
              <CPTInput
                v-model="documentos.nomeResponsavel2"
                label="Nome (Responsável 2)"
              />
            </v-col>
            <v-col cols="12" md="6">
              <CPTInput
                v-model="documentos.cpfResponsavel2"
                v-maska="'###.###.###-##'"
                label="N° do CPF (Responsável 2)"
                placeholder="000.000.000-00"
                :validator="[
                  (cpf) => !cpf || isValidCPF(cpf) || 'CPF inválido',
                ]"
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- <v-col v-if="!isConselhoTutelar" cols="12">
          <v-row>
            <CPTSubtitle label="Documentos" />
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.declaracaoCarteiraTrabalho1"
                accept="image/*,.pdf"
                chips
                counter
                label="Declaração ou Carteira de Trabalho (Responsável 1)*"
                multiple
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.declaracaoCarteiraTrabalho2"
                accept="image/*,.pdf"
                chips
                counter
                label="Declaração ou Carteira de Trabalho (Responsável 2)"
                multiple
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.impossibilidadeFerias1"
                accept="image/*,.pdf"
                chips
                counter
                label="Declaração de impossibilidade de férias (Responsável 1)*"
                multiple
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.impossibilidadeFerias2"
                accept="image/*,.pdf"
                chips
                counter
                label="Declaração de impossibilidade de férias (Responsável 2)"
                multiple
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.vulnerabilidadeSocial"
                accept="image/*,.pdf"
                chips
                counter
                label="Criança em vulnerabilidade social (Documento do CRAS)"
                multiple
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.cpfCrianca"
                accept="image/*,.pdf"
                chips
                counter
                label="Certidão de nascimento ou CPF da criança"
                multiple
              />
            </v-col>

            <v-col cols="12" md="6">
              <CPTFileInput
                v-model="documentos.comprovanteResidencia"
                accept="image/*,.pdf"
                chips
                counter
                label="Comprovante de Residência"
                multiple
              />
            </v-col>
          </v-row>
        </v-col> -->

        <v-col cols="12 d-flex justify-end">
          <CPTBtn
            label="Salvar"
            :loading="saving"
            icon="mdi-content-save"
            @click="validate"
          />
        </v-col>
      </v-form>
    </v-col>

    <DialogPlantao
      v-if="dialogSave"
      :dialog="dialogSave"
      :saving="saving"
      :student="student"
      @close="dialogSave = false"
      @save="onSubmit"
    />
  </v-row>
</template>

<script>
import CPTAutocomplete from "@/components/Autocomplete";
import CPTBtn from "@/components/Btn";
// import CPTFileInput from "@/components/FileInput";
import CPTInput from "@/components/Input";
import CPTSubtitle from "@/components/FormSubtitle";
import CPTTextArea from "@/components/TextArea";
import DialogPlantao from "@/pages/Cadastro/Novo/DialogPlantao.vue";
import Student from "@/models/Student";
import { isAdmin, isGestor, getAtribuicaoAtiva } from "@/plugins/security";
import { cpf } from "cpf-cnpj-validator";
import { last } from "lodash";

export default {
  name: "plantao-ferias",

  components: {
    CPTAutocomplete,
    CPTBtn,
    // CPTFileInput,
    CPTInput,
    CPTSubtitle,
    CPTTextArea,
    DialogPlantao,
  },

  mounted() {
    this.getStates();
  },

  data: () => ({
    cities: [],
    dialog: false,
    dialogSave: false,
    documentos: {},
    enrollment: null,
    loading: false,
    observacao: null,
    processoInscricao: null,
    saving: false,
    state: null,
    student: null,
    valid: true,
  }),

  computed: {
    states() {
      return this.$store.state.address.states;
    },

    isValidEnrollment() {
      return this.enrollment?.toString()?.length === 11;
    },

    isConselhoTutelar() {
      return this.student?.pessoa?.conselheiroNome?.length ? true : false;
    },
  },

  methods: {
    isValidCPF: cpf.isValid,

    validate() {
      if (!this.$refs.form.validate()) {
        return this.showMessage("Verifique os campos obrigatórios!", "warning");
      }

      this.dialogSave = true;
    },

    criarInscricao(matricula_id) {
      const atribuicaoID = getAtribuicaoAtiva().id;
      this.$http
        .post(
          "plantao-ferias",
          { 
            matricula_id, 
            particularidades: this.student.particularidades, 
            observacao: this.observacao 
          },
          { params: { atribuicaoID } },
        )
        .then((inscricao) => {
          this.$router.push(`/protocolo-plantao/${inscricao.id}`);
        })

        .catch((error) => {
          this.showMessage(error, "error");
          this.saving = false;
        });
    },

    async atualizarResponsaveis() {
      const mapDados = {
        id: this.student.pessoa.id,
        cpfMae: this.documentos.cpfResponsavel1.replace(/\D/g, ""),
        nomeMae: this.documentos.nomeResponsavel1,
        cpfPai:
          this.documentos.cpfResponsavel2?.replace(/\D/g, "") || undefined,
        nomePai: this.documentos.nomeResponsavel2 || undefined,
      };

      await this.$erudio
        .put(`pessoas/${this.student.pessoa.id}`, mapDados)
        .catch((error) => this.showMessage(error, "error"));
    },

    async criarInscricaoComArquivos() {
      const atribuicaoID = getAtribuicaoAtiva().id;
      const formData = new FormData();
      formData.append("matricula_id", this.student.matricula_id);
      formData.append("particularidades", this.student.particularidades);
      formData.append("observacao", this.observacao || "");

      if (this.isConselhoTutelar) {
        formData.append("vulnerabilidade_social", true);
      } else {
        await this.atualizarResponsaveis();

        const categoriasDocumentos = {
          declaracao_carteira_trabalho_1: this.documentos
            .declaracaoCarteiraTrabalho1,
          declaracao_carteira_trabalho_2: this.documentos
            .declaracaoCarteiraTrabalho2,
          impossibilidade_ferias1: this.documentos.impossibilidadeFerias1,
          impossibilidade_ferias2: this.documentos.impossibilidadeFerias2,
          vulnerabilidade_social: this.documentos.vulnerabilidadeSocial,
          cpf_crianca: this.documentos.cpfCrianca,
          comprovante_residencia: this.documentos.comprovanteResidencia,
        };

        // Percorre todas as categorias dinamicamente
        Object.entries(categoriasDocumentos).forEach(
          ([nomeCampo, arquivos]) => {
            (arquivos || []).forEach((arquivo) => {
              formData.append("arquivos", arquivo);
              formData.append("arquivos_nomes", nomeCampo);
            });
          },
        );

        formData.append(
          "vulnerabilidade_social",
          this.documentos.vulnerabilidadeSocial ? true : false,
        );
      }

      this.$http
        .post("plantao-ferias", formData, {
          params: { atribuicaoID },
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((inscricao) => {
          this.$router.push(`/protocolo-plantao/${inscricao.id}`);
        })
        .catch((error) => {
          this.saving = false;
          this.showMessage(error, "error");
        });
    },

    async getCities(clearStudentCity) {
      if (clearStudentCity) {
        this.student.endereco.cidade = null;
        this.$refs.form.resetValidation();
      }

      if (!this.state) return;

      this.cities = await this.$http
        .get(`cidade?estado_id=${this.state.id}`)
        .catch((error) => this.showMessage(error, "error"));
    },

    getStates() {
      if (!this.states) this.$store.dispatch("address/getStates");
    },

    async getStudent(codigo) {
      this.loading = true;

      if (await this.hasInscricao(codigo)) {
        this.loading = false;
        return this.showMessage(
          "Já existe uma inscrição para essa matrícula.",
          "error",
        );
      }

      if (await this.isProcessoEncerrado()) {
        this.loading = false;
        return this.showMessage(
          "O prazo de inscrição está encerrado.",
          "error",
        );
      }

      const atribuicaoID = getAtribuicaoAtiva().id;
      this.$http
        .get("matricula", { params: { codigo, atribuicaoID } })
        .then(async (student) => {
          const pessoa = await this.$erudio
            .get(`pessoas/${student.pessoa.id}`)
            .catch((error) => this.showMessage(error, "error"));

          this.documentos.nomeResponsavel1 = pessoa.nomeMae || null;
          this.documentos.cpfResponsavel1 = pessoa.cpfMae || null;
          this.documentos.nomeResponsavel2 = pessoa.nomePai || null;
          this.documentos.cpfResponsavel2 = pessoa.cpfPai || null;
          this.student = new Student(student);
          this.student.matricula_id = student.id;
          this.student.nomeUnidade = student.unidadeEnsino.nomeCompleto;
          this.student.nomeEtapa = student.etapa.nome;
          this.student.particularidades = pessoa.particularidades.length
            ? true
            : false;
          this.student.pessoa = pessoa;

          this.getStates();
          this.state = this.student.endereco.cidade.estado;

          this.getCities();
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.showMessage(error, "error");
        });
    },

    async hasInscricao(enrollment) {
      const inscricao = await this.$http
        .get(`matricula/${enrollment}/inscricao-plantao`)
        .catch((error) => {
          this.showMessage(error, "error");
        });

      return !!inscricao;
    },

    async isProcessoEncerrado() {
      const processos = await this.$http
        .get("/processo-plantao")
        .catch((error) => this.showMessage(error, "error"));

      if (!processos.length) return true;

      const ultimoProcesso = last(processos);
      if (isAdmin() || isGestor()) return ultimoProcesso.encerrado;
      return ultimoProcesso.encerrado_externo;
    },

    onInputEnrollment() {
      this.student = null;
      this.observacao = null;
    },

    onSubmit() {
      this.saving = true;
      if (!this.$refs.form.validate()) {
        this.saving = false;

        return this.showMessage(
          "Verifique as informações inseridas e tente novamente",
          "error",
        );
      }

      this.criarInscricao(this.student.matricula_id);
      // criarInscricaoComArquivos() // descomentar para usar upload de arquivos
    },
  },
};
</script>
